const ApiRootUrl = 'http://lishui.yeshiweb.com:8081/webapi/api/';

module.exports = {
  atrDetail:ApiRootUrl + 'col_article/more_col_articles',//文章列表
  carImg:ApiRootUrl + 'carouse_image/images',//轮播图片
  artInfo:ApiRootUrl + 'col_article/article_info',//文章详情
  recom:ApiRootUrl + 'col_article/hots_articles'//推荐
};